exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.formContainer[data-v-1a13195a]{\r\n  margin-bottom: 4.5rem;\r\n  display: block;\r\n  width: 100%;\r\n  height: 80%;\n}\r\n\r\n", ""]);

// exports
